<template>
  <div>
    <Button type="primary" size="small" style="margin: 5px" @click="add">新增</Button>
    <Table :columns="parentsTable.columns" :data="parentsTable.data"></Table>
    <Modal v-model="showModal" title="编辑">
      <Form :model="parModel" :rules="praRules" ref="parModel" :label-width="100">
        <FormItem label="称谓" prop="relation">
            <Select v-model="parModel.relation" style="width:120px;">
                <Option label="父亲" value="父亲"></Option>
                <Option label="母亲" value="母亲"></Option>
                <Option label="本人" value="本人"></Option>
                <Option label="其他" value="其他"></Option>
            </Select>
        </FormItem>
        <FormItem label="姓名" prop="name">
          <Input type="text" v-model="parModel.name"/>
        </FormItem>
        <FormItem label="手机号" prop="mobile">
          <Input type="text" v-model="parModel.mobile" />
        </FormItem>
        <FormItem label="备注">
          <Input type="text" v-model="parModel.remark"/>
        </FormItem>
      </Form>
     <div slot="footer">
       <Button type="primary" size="small" style="margin-right: 5px;" @click="saveParent('parModel')">确定</Button>
       <Button type="default" size="small" @click="modelcancle">取消</Button>
     </div>
    </Modal>
  </div>
</template>
<script>
  export default {
    name:'parents',
    data(){
      return{
        showModal:false,
        parentsTable:{
          columns:[
            {
              title:'称谓',
              key:'relation',
              align:'center'
            },
            {
              title:'姓名',
              key:'name',
              align:'center'
            },
            {
              title:'手机号',
              key:'mobile',
              align:'center'
            },
            {
              title: '是否绑定微信',
              key: 'openid',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('span', {}, params.row.openid ? '已绑定' : '未绑定'));
                return h('div', {}, opArray);
              }
            },
            {
              title:'备注',
              key:'remark',
              align:'center'
            },
            {
              title: '操作',
              align: 'center',
              render: (h, params) => {
                let self = this;
                let opArray = [];
                opArray.push(h('Button', {
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.parModel.id=params.row.id
                      this.parModel.name=params.row.name
                      this.parModel.mobile=params.row.mobile
                      this.parModel.relation=params.row.relation
                      this.parModel.openid=params.row.openid
                      this.parModel.remark=params.row.remark
                      this.showModal=true
                    }
                  }
                }, '修改'));
                opArray.push(h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title:'确认删除?',
                        content:'确认删除该记录?',
                        onOk(){
                          this.$api.student.delParent({id:params.row.id}).then(res=>{
                            if(res.state=="ok"){
                              this.$Message.success("删除成功")
                              self.getParentsList()
                            }else{
                              this.$Message.error(res.msg);
                            }
                            this.showModal=false;
                          })
                        },
                        onClose(){

                        }
                      })
                    }
                  }
                }, '删除'));
                return h('div', opArray);
              }
            }
          ],
          data:[]
        },
        parModel:{
          id:null,
          name:null,
          relation:null,
          mobile:null,
          openid:null,
          remark:null
        },
        praRules:{
          name:[{required:true,message:'请输入姓名',trigger:'blur'}],
          relation:[{required:true,message:'请输入称谓',trigger:'blur'}],
          mobile:[{required:true,message:'请输入手机号',trigger:'blur'}]
        }
      }
    },
    methods:{
      getParentsList(){
        this.parentsTable.data=[];
        this.$api.student.getParentsList({student_id:this.$route.query.id}).then(res=>{
          if(res.state=="ok"){
            this.parentsTable.data=res.parentsList;
          }else{
            this.$Message.error(res.msg);
          }
        })
      },
      add(){
        this.parModel.id=''
        this.$refs.parModel.resetFields();
        this.showModal=true;
      },
      packagingFormData(){
        let postFormData = {};
        for (var i in this.parModel) {
          if (this.parModel.hasOwnProperty(i)) {
            postFormData['parent.'+i] = this.parModel[i];
          }
        }
        if(this.$route.query.id!=null) {
          postFormData['parent.student_id'] = this.$route.query.id
        }
        return postFormData;
      },
      saveParent(name){
        let self = this
        self.$refs[name].validate((valid) => {
          if (valid) {
            this.$api.student.saveParent(this.packagingFormData()).then(res=>{
              if(res.state=="ok"){
                this.$Message.success("保存成功")
                this.getParentsList()
              }else{
                this.$Message.error(res.msg)
              }
              this.showModal=false
            })
          }
        })
      },
      init(){
        this.parentsTable.data=[];
      },
      modelcancle(){
        this.showModal=false
        this.$refs.parModel.id=null
        this.$refs.parModel.resetFields()
      }
    },
    mounted() {
      this.getParentsList();
    },
  }
</script>
